import React from 'react';

const Card = ({img}) => {
	return (
		<div className='card'>
			<img src={`./img/galeria/${img}.jpg`} alt='galería' />
		</div>
	);
};

export default Card;
